import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const NotFound = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center text-center">
        <Col md={6}>
          <h1 className="display-1 fw-bold">404</h1>
          <h2 className="mb-4">Sayfa Bulunamadı</h2>
          <p className="mb-4">
            Aradığınız sayfa bulunamadı. Sayfa kaldırılmış veya adresi değişmiş olabilir.
          </p>
          <Link to="/">
            <Button variant="primary">
              <FontAwesomeIcon icon={faHome} className="me-2" />
              Ana Sayfaya Dön
            </Button>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound; 